import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { Button } from '../../components/ui/Button.jsx';
import { Modal } from '../../components/ui/Modal.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { financeApi } from '../../services/financeApi.js';

const empty = () => ({ code: '', name: '', currency: 'CHF' });

export function CompanyCodeModal({ open, onClose }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [form, setForm] = useState(empty);
  const [error, setError] = useState(null);

  useEffect(() => { if (open) { setForm(empty()); setError(null); } }, [open]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = useMutation({
    mutationFn: (body) => financeApi.createCompanyCode(body),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['finance', 'intercompany'] }); onClose(); },
    onError: (err) => setError(err?.message || t('common.loadError')),
  });

  function submit(e) {
    e.preventDefault();
    setError(null);
    if (!form.code.trim() || !form.name.trim()) { setError(t('ic.error.companyRequired')); return; }
    save.mutate({ code: form.code.trim(), name: form.name.trim(), currency: form.currency || 'CHF' });
  }

  return (
    <Modal open={open} onClose={onClose} title={t('ic.company.title')}
      footer={<><Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="primary" onClick={submit} disabled={save.isPending}>{save.isPending ? `${t('common.save')}…` : t('common.save')}</Button></>}>
      <form onSubmit={submit} className="form-stack">
        <div className="field-row">
          <label className="field" style={{ maxWidth: 140 }}><span className="field-label">{t('ic.col.company')}</span>
            <input className="input mono" value={form.code} onChange={set('code')} placeholder="1000" required />
          </label>
          <label className="field"><span className="field-label">{t('ic.field.name')}</span>
            <input className="input" value={form.name} onChange={set('name')} required />
          </label>
          <label className="field" style={{ maxWidth: 110 }}><span className="field-label">{t('ic.field.currency')}</span>
            <input className="input mono" value={form.currency} onChange={set('currency')} maxLength={3} />
          </label>
        </div>
        {error && <div className="alert danger">{error}</div>}
      </form>
    </Modal>
  );
}
